import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { academylist, noticreate } from "../../../services/admin";
import Select from "react-select";
import { roleList } from "../../../services/master";
import { toast } from "react-toastify";

export default function Addnotification() {
  const navigate = useNavigate();
  const [ntitle, setNTitle] = useState("");
  const [nmessage, setNMessage] = useState("");
  const [npri, setNPri] = useState("");
  const [nfile, setNFile] = useState("");
  const [nfileerr, setNFileerr] = useState("");

  const [aclist, setACList] = useState([]);
  const [acaid, setAcaID] = useState("");
  const [arole, setARole] = useState("");
  const [rlist, setRList] = useState([]);

  function notifile(event) {
    setNFileerr("");
    setNFile("");
    if (event.target.files.length !== 0) {
      if (event.target.files[0].name.match(/\.(jpg|jpeg|png|pdf)$/i)) {
        setNFile(event.target.files[0]);
      } else {
        setNFileerr("Attachment should be jpg, jpeg, png or pdf format");
      }
      var size = event.target.files[0].size / 1024 / 1024;
      if (size > 5) {
        setNFileerr("Attachment size should be less than 5MB");
      }
    }
  }
  const [nerror, setNError] = useState("");
  function submitnoti(e) {
    e.preventDefault();
    setNError("");
    let valid = "";
    let nrole = ""
    if (localStorage.getItem("Role") === "1") {
      if (acaid === "") {
        valid = "Please Select Academy";
        setNError("Please Select Academy");
      }
    }
    if (valid === "") {
      if (ntitle !== "") {
        if (arole !== "") {
          for (let i = 0; i < arole.length; i++) {
            if (nrole == "") {
              nrole = arole[i].value;
            } else {
              nrole = nrole + "," + arole[i].value
            }
          }
        }
        if (nrole !== "") {
          if (nmessage !== "") {
            const temp = new FormData();
            if (localStorage.getItem("Role") === "1" && acaid !== "") {
              temp.append("academy_id", acaid.value);
            }
            temp.append("title", ntitle);
            temp.append("noti_sent_role", nrole);
            temp.append("priority", npri);
            temp.append("message", nmessage);
            temp.append("noti_file", nfile);

            noticreate(temp).then((res) => {
              if (res.status === true) {
                toast.success(res.message);
                navigate("/circular/circularlist");
              } else {
                if (res.data.length !== 0) {
                  setNError(res.data.join(','));
                }
              }
            });
          } else {
            setNError("Please Enter Message");
          }
        } else {
          setNError("Please Select Notification For");
        }
      } else {
        setNError("Please Enter Title");
      }
    }
  }

  useEffect(() => {
    academylist().then((res) => {
      if (res.status === true) {
        let arr = [];
        if (res.data.details.length > 0) {
          for (let i = 0; i < res.data.details.length; i++) {
            arr.push({
              value: res.data.details[i].id,
              label:
                res.data.details[i].name + " - " + res.data.details[i].code,
            });
          }
          setACList(arr);
        }
      }
    });

    roleList().then((res) => {
      if (res.status === true) {
        let arr = [{ value: 0, label: "All" }];
        if (res.data.length > 0) {
          for (let i = 0; i < res.data.length; i++) {
            arr.push({
              value: res.data[i].id,
              label: res.data[i].name,
            });
          }
          setRList(arr);
        }
      }
    });
    if (localStorage.getItem("AAcademy") != null) {
      academylist().then((res) => {
        if (res.status === true) {
          let arr = [];
          if (res.data.details.length > 0) {
            for (let i = 0; i < res.data.details.length; i++) {
              if (res.data.details[i].id == localStorage.getItem("AAcademy")) {
                arr.push({
                  value: res.data.details[i].id,
                  label:
                    res.data.details[i].name + " - " + res.data.details[i].code,
                });
              }
              if (arr.length > 0) {
                setAcaID(arr[0]);
              }
            }
           
          }
        }
      });
    }
  }, []);

  function handleAcademy(e) {
    if (e !== null) {
      setAcaID(e);
    } else {
      setAcaID("");
    }
  }
  function handleRole(e) {
    if (e !== null) {
      const edata = e.some((item) => item.value === 0);
      if (edata) {
        setARole([{ value: 0, label: "All" }]);
      } else {

        setARole(e);
      }
    } else {
      setARole("");
    }
  }
  return (
    <div>
      <div className="page-header">
        <h2 className="main-content-title tx-24 mg-b-5">Add Circular</h2>
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <a>Circular</a>
          </li>
          <li className="breadcrumb-item active" aria-current="page">
            Add Circular
          </li>
        </ol>
      </div>
      <div className="content-body">
        <div className="container-fluid">
          <div className="card">
            <div className="card-header">
              <h2 className="main-content-title tx-24 mg-b-5">
                Add Circular
              </h2>{" "}
            </div>
            <div className="card-body">
              <div className="row">
                <div className="col-xl-12 col-lg-12">
                  <div className="row">
                    {localStorage.getItem("Role") === "1" && (
                      <div className="col-xl-6 col-sm-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Select Academy{" "}
                            <span className="text-danger"> *</span>
                          </label>
                          <Select
                            className="default-select"
                            placeholder="Select Academy"
                            value={acaid}
                            options={aclist}
                            onChange={handleAcademy}
                            isSearchable={true}
                            isClearable
                            hidden
                          />
                        </div>
                      </div>
                    )}
                    <div className="col-xl-6 col-sm-6">
                      <div className="mb-3">
                        <label className="form-label">
                          Title<span className="text-danger"> *</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter Title"
                          onChange={(e) => setNTitle(e.target.value)}
                          value={ntitle}
                        />
                      </div>
                    </div>
                    <div className="col-xl-6 col-sm-6">
                      <div className="mb-3">
                        <label className="form-label">
                          Notification For
                          <span className="text-danger"> *</span>
                        </label>
                        <Select
                          className="default-select"
                          placeholder="Select Notification For"
                          value={arole}
                          options={rlist}
                          onChange={handleRole}
                          isSearchable={true}
                          isMulti
                          isClearable
                          hidden
                        />
                      </div>
                    </div>
                    <div className="col-xl-6 col-sm-6">
                      <div className="mb-3">
                        <label className="form-label">Priority</label>
                        <select
                          className="default-select form-control wide"
                          onChange={(e) => setNPri(e.target.value)}
                          value={npri}
                        >
                          <option value="" disabled>
                            Select Priority
                          </option>
                          <option value="High">High</option>
                          <option value="Medium">Medium</option>
                          <option value="Low">Low</option>
                        </select>
                      </div>
                    </div>
                    <div className="col-xl-6 col-sm-6">
                      <div className="mb-3">
                        <label className="form-label">
                          Message
                          <span className="text-danger"> *</span>
                        </label>
                        <textarea
                          className="form-control"
                          rows={4}
                          placeholder="Enter Message"
                          onChange={(e) => setNMessage(e.target.value)}
                          value={nmessage}
                        />
                      </div>
                    </div>
                    <div className="col-xl-6 col-sm-6">
                      <div className="mb-3">
                        <label className="form-label">Attachment</label>
                        <input
                          type="file"
                          className="form-control"
                          accept=".jpeg, .jpg, .png, .pdf"
                          onChange={notifile}
                        />
                        {nfileerr && (
                          <span className="text-danger">{nfileerr}</span>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {nerror !== "" && <span className="text-danger">{nerror}</span>}

              <div className="res-right mt-2 me-4">
                <button className="btn btn-success" onClick={submitnoti}>
                  Submit
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
